import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSawingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			style: {},
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M64.4,85.5c0.1,0,0.2,0,0.4-0.1h0l20.6-11.9c0.2-0.1,0.4-0.4,0.4-0.6V61c0-0.3-0.1-0.5-0.4-0.6 l-5.1-3c-0.1-0.1-0.2-0.1-0.4-0.1h-8.9v-8.9c0-0.2-0.1-0.3-0.2-0.5c0,0,0,0,0,0c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0l-36.4-21 c-0.2-0.1-0.5-0.1-0.7,0L13,38.7c-0.2,0.1-0.4,0.4-0.4,0.6v11.9c0,0.3,0.1,0.5,0.4,0.6L28.7,61c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0H38v8.9c0,0.3,0.1,0.5,0.4,0.6l25.7,14.9C64.2,85.5,64.3,85.5,64.4,85.5z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M85.7,59.8c-1.2-0.7-2.3-1.3-3.5-2c-0.9-0.5-1.6-1.1-2.6-1.1c-2.6-0.1-5.3,0-7.9,0 c0-2.1,0-4.2,0-6.2c0-1.3,0.3-2.5-0.9-3.3C68.1,45.3,45,32.3,36.4,27.3c-0.6-0.3-1.2-0.8-1.8-1c-1.2-0.5-2.7,0.8-3.8,1.4 C26.4,30.3,14.4,37.1,13,38c-1.3,0.8-1,2.2-1,3.5c0,2.6,0,5.2,0,7.9c0,1.5-0.2,2.5,1.2,3.3c4.1,2.5,8.3,4.8,12.5,7.2 c1,0.6,2.1,1.5,3.2,1.7c2,0.4,7.7,0,8.4,0c0,2.6-0.2,5.4,0,8c0.1,1.6,2.1,2.2,3.3,2.9c5.8,3.4,11.7,6.7,17.5,10.1 c1.8,1,3.5,2.2,5.4,3.1c1.4,0.7,3-0.8,4.2-1.5c5.6-3.2,11.1-6.4,16.7-9.6c0.8-0.5,1.7-0.8,1.9-1.9c0.1-1.1,0-2.3,0-3.4 c0-2,0-4,0-6C86.4,62.5,86.8,60.4,85.7,59.8z M27.8,49.2v8.9l-13.1-7.6v-8.9L27.8,49.2z M65.4,47.1c-7.1,0-29.4,0-33.5,0 c-0.7,0-1.7,0.2-2.4,0c-0.8-0.2-1.8-1-2.5-1.4c-3.7-2.1-7.3-4.2-11-6.4l18-10.4L65.4,47.1z M82.4,61l-18,10.4l-20.8-12 c11.3,0,22.6,0,33.9,0c0.6,0,1.4-0.1,2,0C80.5,59.6,81.5,60.5,82.4,61z M69,49.7v7c-9.8,0-19.5,0-29.3,0c-1.7,0-2.3,0.4-2.3,2.3 h-7v-9.3H69z M63.1,73.6v8.9L40,69.2v-8.9L63.1,73.6z M83.7,63.3v8.9l-18,10.4v-8.9L83.7,63.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M8.3,52.1h-2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h2c0.7,0,1.2-0.5,1.2-1.2         C9.5,52.6,9,52.1,8.3,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M71.8,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C73,52.6,72.5,52.1,71.8,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M87.7,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C88.9,52.6,88.4,52.1,87.7,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M79.8,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C81,52.6,80.4,52.1,79.8,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M63.9,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C65.1,52.6,64.6,52.1,63.9,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M24.2,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C25.4,52.6,24.8,52.1,24.2,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M56,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C57.2,52.6,56.6,52.1,56,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M32.1,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C33.3,52.6,32.8,52.1,32.1,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M16.2,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C17.4,52.6,16.9,52.1,16.2,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M40.1,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C41.3,52.6,40.7,52.1,40.1,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M48,52.1h-4c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h4c0.7,0,1.2-0.5,1.2-1.2         C49.2,52.6,48.7,52.1,48,52.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: " M93.7,52.1h-2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h2c0.7,0,1.2-0.5,1.2-1.2         C94.9,52.6,94.3,52.1,93.7,52.1z"
		})
	] }) })
});
export default SvgSawingSm;
